import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    elementId: String,
  };

  toggle() {
    const element = document.getElementById(this.elementIdValue);
    element.classList.toggle("hidden");
  }
}
